import _State from '@states/_State.js';

const PreviewState = _State('preview', 'setPreview', null);

export default PreviewState;
